// See: backend/docs/driver-scheduler.md §11 — GET /schedule
//
// Tek bir trip için Gantt block'u. Konum/genişlik dakika tabanlı hesaplanır.
// Kilit ikonu opsiyonel — assignment.locked === true ise gösterilir.
//
// Sprint 2: lock toggle inline; tıklayınca onToggleLock(trip, !locked) çağrılır.

import React from "react";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

import { buildTripTooltipLines } from "../scheduleLabels";

const KIND_COLOR = {
  SHIFT_PERSONEL: { bg: "#1976d2", border: "#0d47a1", fg: "#fff" },
  TRANSFER: { bg: "#ef6c00", border: "#b53d00", fg: "#fff" },
  STANDARD_PERSONEL: { bg: "#90a4ae", border: "#546e7a", fg: "#fff" },
  VEHICLE_ROUTE: { bg: "#388e3c", border: "#1b5e20", fg: "#fff" },
};

const hhmmToMinutes = (s) => {
  if (!s || typeof s !== "string") return 0;
  const [h, m] = s.split(":").map((p) => parseInt(p, 10));
  if (Number.isNaN(h) || Number.isNaN(m)) return 0;
  return h * 60 + m;
};

/**
 * @param {Object} props
 * @param {Object} props.trip — schedule.drivers[i].trips[j] elemanı
 * @param {number} props.gridStartMin — Gantt grid'inin başlangıç dakikası (örn. 360 = 06:00)
 * @param {number} props.gridEndMin — Gantt grid'inin bitiş dakikası (örn. 1380 = 23:00)
 * @param {boolean} props.canLock — Lock toggle gösterilsin mi (sadece SHIFT/TRANSFER için)
 * @param {Function} props.onToggleLock — async (trip, nextLocked) => void
 * @param {boolean} props.isLockBusy
 */
const TripBlock = ({ trip, gridStartMin = 360, gridEndMin = 1380, canLock, onToggleLock, isLockBusy }) => {
  const { t } = useTranslation();

  if (!trip) return null;

  const startMin = Math.max(gridStartMin, hhmmToMinutes(trip.startTime));
  const endMin = Math.min(gridEndMin, hhmmToMinutes(trip.endTime));
  const span = Math.max(0, gridEndMin - gridStartMin);
  if (span <= 0 || endMin <= startMin) return null;

  const left = ((startMin - gridStartMin) / span) * 100;
  const width = Math.max(0.6, ((endMin - startMin) / span) * 100);

  const color = KIND_COLOR[trip.kind] || KIND_COLOR.STANDARD_PERSONEL;
  const locked = !!trip.assignment?.locked;

  const tooltipText = buildTripTooltipLines(trip, t).join("\n");

  return (
    <Tooltip title={<span style={{ whiteSpace: "pre-line" }}>{tooltipText}</span>}>
      <div
        className="trip-block"
        style={{
          left: `${left}%`,
          width: `${width}%`,
          backgroundColor: color.bg,
          borderColor: color.border,
          color: color.fg,
        }}
      >
        <span className="trip-block__name">{trip.name || trip.serviceId}</span>
        {/* {canLock && (
          <button
            type="button"
            className="trip-block__lock-btn"
            disabled={isLockBusy}
            onClick={(e) => {
              e.stopPropagation();
              if (typeof onToggleLock === "function") onToggleLock(trip, !locked);
            }}
            title={locked ? "Kilidi aç" : "Kilitle"}
          >
            {locked ? <LockIcon fontSize="inherit" /> : <LockOpenIcon fontSize="inherit" />}
          </button>
        )} */}
      </div>
    </Tooltip>
  );
};

export default TripBlock;
